export type SequenceType = 'aa' | 'nuc';
export const sequenceTypes: SequenceType[] = ['aa', 'nuc'];
